import { Row, Col, Divider, Icon, Popover } from "antd";
import { withTheme } from "styled-components";
import G2 from "@antv/g2";
import moment from "moment";
import React, { Component } from "react";

import { Container, Title } from "./style";
import ColorUtil from "../../../util/ColorUtil";
import GraphConst from "../../../constants/graph";
import IndividualStressTestUser from "./IndividualStressTestUser";

const { RISK } = GraphConst;

class StressIndividualUser extends Component {
    state = {}

    componentDidMount() {
    	const { chartId, stress, theme, visualColorKey } = this.props;
    	this.chart = new G2.Chart({
    		container: chartId,
    		height: 300,
    		padding: [10, 10, 30, 30],
    		forceFit: true
    	});
    	const stressFilter = stress ?
    		stress
    			.filter(value => value.level != null)
    			.map(value => {
    				return {
    					date: moment.unix(value.start).format("MM/DD/YYYY"),
    					level: value.level + 1
    				};
    			}) : [];
    	this.chart.source(stressFilter);
    	this.chart.scale("level", { max: 5 });
    	const color = ColorUtil.getVisualizeColor(theme, visualColorKey, 0, 1);
    	this.chart.interval().position("date*level").style({ fill: color });
    	this.chart.render();
    	window.dispatchEvent(new Event("resize"));
    }

    componentWillReceiveProps(nextProps) {
    	const { stress } = nextProps;
    	const stressFilter = stress ?
    		stress
    			.filter(value => value.level != null)
    			.map(value => {
    				return {
    					date: moment.unix(value.start).format("MM/DD/YYYY"),
    					level: value.level + 1
    				};
    			})
    		: [];
    	this.chart.source(stressFilter);
    	this.chart.render();
    }

    render() {
    	const { chartId, title, provider, stress = [] } = this.props;
    	const stressFilter = stress ?
    		stress
    		// .map(value => { value.level = 1; return value })
    			.filter(value => value.level != null)
    		: [];
    	return (
    		<Container>
    			<div style={{ marginBottom: 10 }}>
    				<Icon type="user" style={{ marginRight: 10, fontSize: 22 }} />
    				<Title style={{ display: "inline" }}>{title}</Title>
    			</div>
    			<Row gutter={16} type="flex" justify="center">
    				<Col span={11}>
    					<div id={chartId} />
    				</Col>
    				<Col>
    					<Divider type="vertical" style={{ height: 300, padding: "0 0", margin: "8px" }} />
    				</Col>
    				<Col span={11}>
    					<div>
    						<div style={{ fontSize: 14, fontWeight: "bold", marginBottom: 10 }}>
    							{provider ? "Stress level" : "Stress test results"}
    						</div>
    						{
    							stressFilter.length > 0 ? stressFilter.map((value, key) =>
    								<IndividualStressTestUser
    									key={key}
    									id={key + 1}
    									isProvider={provider}
    									value={value} />)
    								: <div style={{ textAlign: "center" }}>No data</div>
    						}
    					</div>
    				</Col>
    			</Row>
    		</Container>
    	);
    }
}

export default withTheme(StressIndividualUser);

const stress_test_results_mock = [
	{
		date: "14/01/2018",
		lv: 1,
		provider: {
			duration: "30 min",
			tag: ["Work", "Love", "Money"],
			provider: "Dr. John Smith"
		}
	},
	{
		date: "15/01/2018",
		lv: 2,
		provider: {
			duration: "30 min",
			tag: ["Work", "Love", "Money"],
			provider: "Dr. John Smith"
		}
	},
	{
		date: "16/01/2018",
		lv: 3,
		provider: {
			duration: "30 min",
			tag: ["Work", "Love", "Money"],
			provider: "Dr. John Smith"
		}
	},
	{
		date: "17/01/2018",
		lv: 4,
		provider: {
			duration: "30 min",
			tag: ["Work", "Love", "Money"],
			provider: "Dr. John Smith"
		}
	},
	{
		date: "18/01/2018",
		lv: 5,
		provider: {
			duration: "30 min",
			tag: ["Work", "Love", "Money"],
			provider: "Dr. John Smith"
		}
	},
];

const data = [
	{ date: "14/01/2018", level: 1 },
	{ date: "16/01/2018", level: 2 },
	{ date: "20/01/2018", level: 3 },
];


// WEBPACK FOOTER //
// ./src/components/report/individual_user/StressIndividualUser.js